import script from "./Subsidiaries.vue?vue&type=script&setup=true&lang=js"
export * from "./Subsidiaries.vue?vue&type=script&setup=true&lang=js"

import "./Subsidiaries.vue?vue&type=style&index=0&id=20246514&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20246514"]])

export default __exports__